





















import {Component, Prop, Watch, Vue} from 'vue-property-decorator';

@Component({
    inheritAttrs: false,
    model: {
        prop: 'value',
        event: 'custom-input',
    },
})
export default class CNumberField extends Vue {
    @Prop({required: true}) value!: number | null;
    @Prop({default: true, type: Boolean}) showChangeState!: boolean;
    @Prop({default: false, type: Boolean}) nullable!: boolean;
    @Prop() initialValue!: number | undefined;
    @Prop({default: false, type: Boolean}) lazy!: boolean;
    @Prop({default: undefined}) fractionDigits!: number | string | undefined;
    @Prop() rules!: any[];
    @Prop({default: 0}) min!: number | string;
    @Prop({default: Number.MAX_SAFE_INTEGER}) max!: number | string;
    @Prop({default: 'plywood lighten-1', type: String}) color!: string;
    @Prop() errorKey!: string;
    @Prop() errors!: any;

    private localInitialValue: number | null = null;
    private internalKey = 0;
    private errorMsg: string | null = null;

    get inputNumberClasses() {
        const classes: string[] = [];
        if (this.realInitialValue != this.value && this.showChangeState) classes.push('changed');
        return classes;
    }

    get listeners() {
        if (this.lazy) {
            return Object.assign({}, this.$listeners, {
                change: (value: any) => this.$emit('custom-input', this.onValueChange(value)),
            });
        } else {
            return Object.assign({}, this.$listeners, {
                input: (value: any) => this.$emit('custom-input', this.onValueChange(value)),
                change: (value: any) => this.$emit('custom-input', this.onValueChange(value)),
            });
        }
    }

    get realInitialValue() {
        return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
    }

    get formattedValue() {
        let value = typeof this.value === 'string' ? +this.value : this.value;
        return this.fractionDigits !== undefined && value !== null ? value.toFixed(+this.fractionDigits) : value;
    }

    get realRules() {
        return this.rules
            ? this.rules
            : [
                  (v: any) => {
                      if (this.nullable)
                          return (+v >= +this.min && +v <= +this.max) || `${this.min} <= x  <= ${this.max}`;
                      return (v !== null && +v >= +this.min && +v <= +this.max) || `${this.min} <= x  <= ${this.max}`;
                  },
              ];
    }

    @Watch('errors', {deep: true})
    onErrorsChange(value: any) {
        if (!this.errorKey) return console.warn('please provide error-key');
        if (this.errorKey in value) {
            this.errorMsg = value[this.errorKey][0];
        } else {
            this.errorMsg = null;
        }
    }

    @Watch('value')
    onChangeValue(value: string) {
        if (this.errorMsg) this.errorMsg = null;
    }

    created() {
        this.localInitialValue = this.value;
    }

    updateInternalKey() {
        this.internalKey += 1;
    }

    onValueChange(value: string) {
        if (value === '') {
            if (this.nullable) return null;
            else return +this.min;
        } else {
            if (+value > +this.max) return +this.max;
            if (+value < +this.min) return +this.min;
            return parseFloat(value);
        }
    }
}
